export enum Feedback {
  THUMB_UP = "1",
  THUM_DOWN = "-1",
  NULL = "0"
}